import { useDeferred, type UseDeferredReturn } from '../../../composables/useDeferred';
import { accountDeferred, prepareTokenDeferred, addTrialDeferred, planDeferred } from '../../../utils/account';
import type { Account } from '@patsnap-utils/biz';
import type Passport from '@patsnap-utils/passport/src/passport';

/**
 * 响应式获取 Passport 实例
 * @returns { value, isLoading, refresh }
 */
export function usePrepareToken(): UseDeferredReturn<Passport> {
    return useDeferred(prepareTokenDeferred);
}

/**
 * 响应式获取用户账号信息
 * @returns { value, isLoading, refresh }
 */
export function useAccount(): UseDeferredReturn<Account> {
    return useDeferred(accountDeferred);
}

/**
 * 响应式获取试用标志
 * @returns { value, isLoading, refresh }
 */
export function useAddTrial(): UseDeferredReturn<boolean> {
    return useDeferred(addTrialDeferred);
}

/**
 * 响应式获取计划信息
 * @returns { value, isLoading, refresh }
 */
export function usePlan(): UseDeferredReturn<{ isFreemium: boolean; isPersonal: boolean }> {
    return useDeferred(planDeferred);
}

